import React from 'react'
import Header from '../../Header/Header'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../innerpage.css'
import { Row, Container, Col } from 'react-bootstrap'

import usaguideline from '../../../images/usaguideline.png'

const UsaGuidlineBanner = () => {
    return (
        <>
            <div className='innerbanner pt-4 usabanner'>
                <Header></Header>
                <div className='container-fluid'>
                    <Container>
                        <Row className='d-flex justify-content-center align-items-center'>
                            <Col md={5}>
                                <img src={usaguideline} alt="usaguideline" className='animated2 infinite fadeInLeftRight'></img>
                            </Col>
                            <Col md={7}>
                                <h2>Visa Guidelines for  <span>USA</span></h2>
                                <p>Your dream destination is 8431 miles away from your reality.  </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default UsaGuidlineBanner